// extracted by mini-css-extract-plugin
export var phone = "_3t-0";